"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var draggable_directive_1 = require("./directives/draggable.directive");
var droppable_directive_1 = require("./directives/droppable.directive");
var ng2_drag_drop_service_1 = require("./services/ng2-drag-drop.service");
var Ng2DragDropModule = /** @class */ (function () {
    function Ng2DragDropModule() {
    }
    Ng2DragDropModule.forRoot = function () {
        return {
            ngModule: Ng2DragDropModule,
            providers: [ng2_drag_drop_service_1.Ng2DragDropService]
        };
    };
    Ng2DragDropModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [],
                    declarations: [
                        draggable_directive_1.Draggable,
                        droppable_directive_1.Droppable
                    ],
                    exports: [
                        draggable_directive_1.Draggable,
                        droppable_directive_1.Droppable
                    ]
                },] },
    ];
    /** @nocollapse */
    Ng2DragDropModule.ctorParameters = function () { return []; };
    return Ng2DragDropModule;
}());
exports.Ng2DragDropModule = Ng2DragDropModule;
//# sourceMappingURL=ng2-drag-drop.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-drag-drop/src/ng2-drag-drop.module.js
// module id = 900
// module chunks = 9